import { Schema } from 'normalizr';
import { transformUtil } from '@eb/transformation-utils';

const userInstrumentsSchema = new Schema('user_instruments');

export const transformUserInstruments = (data) => {
    const transformedUserInstruments = transformUtil({
        response: data,
        schema: userInstrumentsSchema,
    });

    return transformedUserInstruments.entities.user_instruments[
        transformedUserInstruments.result
    ];
};
